<template>
    <div>
      <router-view id="app"></router-view>
      <vue-canvas-nest :config="{color: '0,0,0', opacity: .2,count: 8}"></vue-canvas-nest>
    </div>
</template>

<script>
  import Vue from 'vue'
  import App from './App'
  import router from './router'
  import vueCanvasNest from 'vue-canvas-nest'


export default {
  name: 'App',
  components: { vueCanvasNest  }
}

var STORE = {
  login: {
    name: ""
  },
  //日期显示时，今年不显示年
  cuur_year : new Date().getFullYear() + "-"
  //日期显示时，今年不显示年
  ,cuur_year_month_date : new Date().getFullYear() + "-" + (new Date().getMonth() + 1)  + "-" + new Date().getDate()
  //提示数据
  ,in_stock_type_all : []
}

Vue.prototype.STORE = STORE
 // router.push("/Login");
router.replace("/Front");
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin:0;
  height:100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue